<form novalidate #propertyAgencyReferenceSectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async">
        <tg-col md="6" sm="12">
            <tg-input-container
                class="property-agency-reference-section__container"
                label="Agency reference #"
                showRemainingCharacters="false"
            >
                <input
                    tgTextInput
                    ngModel
                    name="agencyReference"
                    [validation]="
                        validation.propertyDescription.agencyReference
                            | toValidator
                    "
                    (blur)="publish()"
                    [(ngModel)]="draftData.propertyDescription.agencyReference"
                />
            </tg-input-container>
        </tg-col>
    </tg-row>
</form>
